<nav aria-label="Pagination">
  <ul>
    <li>
      <button
        type="button"
        aria-label="Page précédente"
        [attr.aria-disabled]="current === 1"
        [disabled]="current === 1"
        (click)="onPrevious()"
      >
        <i class="fa fa-chevron-left" aria-hidden="true"></i>
      </button>
    </li>
    @for (page of pages; track page; let i = $index) {
      <li>
        @if (page !== -1) {
          <a
            class="internal"
            [attr.aria-current]="page === current ? 'page' : null"
            [attr.aria-label]="
              page === current
                ? 'Page courante, page ' + page
                : 'Aller à la page ' + page
            "
            [class.current]="page === current"
            tabindex="0"
            (click)="onGoTo(page)"
            (keyup.enter)="onGoTo(page)"
            >{{ page }}</a
          >
        } @else {
          <a class="more"> ... </a>
        }
      </li>
    }
    <li>
      <button
        type="button"
        aria-label="Page suivante"
        [attr.aria-disabled]="current === total"
        [disabled]="current === total"
        (click)="onNext()"
      >
        <i class="fa fa-chevron-right" aria-hidden="true"></i>
      </button>
    </li>
  </ul>
</nav>
